module.exports = __webpack_public_path__ + "img/logo.99553e0b.png";